import styled from 'styled-components';
import { StepModalOption } from '../styled';
import { Breakpoints } from '../../../styled/constants';

export const SelectCategoryOptionWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  width: 100%;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const SelectCategoryOption = styled(StepModalOption)`
  padding: 18px;
  text-align: center;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 30px 15px;
  }
`;
